import { render, staticRenderFns } from "./SendNotices.vue?vue&type=template&id=03b092ea"
import script from "./SendNotices.vue?vue&type=script&lang=js"
export * from "./SendNotices.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports